<template>
    <span :data-tooltip="text" data-side="top" tabindex="0">
        &#9432;
    </span>
</template>

<script>
export default {
    name: 'tooltip',
    props:{
        text: String
    }

}
</script>
<style lang="scss">

[data-tooltip][tabindex="0"] {
  
  color: var(--highlight-color);
  display: inline-block;
  position: relative;
  
  &::after {
    content: attr(data-tooltip);
    font-size: 11px;
    color: var(--primary-text-color);
    padding: 5px;
    
    display: none;
    position: absolute;
    bottom: 110%;
    left: 50%;

    border: 1px solid var(--button-border-color);
    border-radius: 5px;
    
    max-width: 300px;
    transform: translateX(-50%);
    white-space: nowrap;
    background-color: var(--background);
     
  }
  
  &::before {
    display: none;
    position: absolute;
    bottom: 110%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, 50%) rotate(45deg);
    width: 6px;
    height: 6px;
    border: solid var(--button-border-color);
    border-width: 0 1px 1px 0;
    background-color:  var(--background);
    content: '';
  }
  
  &:focus,
  &:hover {
    text-decoration: none;
    &::after,
    &::before {
      display: block;
    }
  }
}

</style>